import { t } from "i18next";
import { Typography } from "neetoui";
import { equals } from "ramda";
import { Trans } from "react-i18next";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import routes from "src/route";

const Header = () => {
  const history = useHistory();
  const location = useLocation();
  const handleHomeClick = event => {
    if (equals(location.pathname, routes.favorites)) {
      event.preventDefault();
      history.goBack();
    }
  };

  return (
    <div className="fixed z-10 flex h-16 w-full flex-row items-center border-b border-gray-300 bg-white p-4">
      <Typography style="h1" weight="bold">
        <Trans
          components={{ span: <span className="text-blue-700" /> }}
          i18nKey="title.headerTitle"
        />
      </Typography>
      <div className="mx-10 justify-around space-x-10 space-y-1 text-lg font-medium">
        <NavLink
          exact
          activeClassName="text-blue-700"
          to={routes.root}
          onClick={handleHomeClick}
        >
          {t("header.home")}
        </NavLink>
        <NavLink exact activeClassName="text-blue-700" to={routes.favorites}>
          {t("header.favourites")}
        </NavLink>
      </div>
    </div>
  );
};

export default Header;
